import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactPaginate from 'react-paginate';

interface PaginationProps {
  totalPages: number;
  handlePageChange: (selectedItem: { selected: number }) => void;
  currentPage: number;
}

export function Pagination({
  totalPages,
  handlePageChange,
  currentPage,
}: PaginationProps): JSX.Element {
  return (
    <div>
      <ReactPaginate
        pageCount={totalPages}
        pageRangeDisplayed={3}
        marginPagesDisplayed={1}
        onPageChange={handlePageChange}
        activeClassName="bg-primary text-white"
        initialPage={currentPage}
        previousLabel={
          <button
            className="rounde flex h-8 w-8 items-center justify-center rounded-md bg-white p-[6px] text-black"
            type="button"
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
        }
        nextLabel={
          <button
            className="flex h-8 w-8 items-center justify-center rounded-md bg-white p-[6px] text-black"
            type="button"
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        }
        pageClassName="rounded-md"
        containerClassName="flex w-fit items-center gap-2 dark:text-white text-default-gray-950"
        pageLinkClassName="flex bg-primary/20 items-center justify-center w-8 h-8 rounded-md"
      />
    </div>
  );
}
